/**
 * Disclaimer de non-responsabilité — pied de mémo et de verdict/observations.
 * DA Hōjin : filet doré, label or, prose grise lisible. Compatible fond clair
 * (paper/ivoire) et fond sombre (noir). Discret mais contraste AA.
 */
type Tone = "light" | "dark" | "auto";
type Variant = "default" | "verif";

export function NanaeDisclaimer({
  tone = "auto",
  variant = "default",
}: {
  tone?: Tone;
  variant?: Variant;
}) {
  const isDark = tone === "dark";
  const isAuto = tone === "auto";

  // Couleurs adaptées : sur fond clair, gris graphite (~#3D3F44) pour AA ;
  // sur fond sombre, ivoire atténué. En "auto", on s'appuie sur les tokens.
  const bodyColor = isDark
    ? "rgba(247,242,234,0.78)"
    : isAuto
      ? "var(--qv3-grey-700, #3D3F44)"
      : "#3D3F44";

  const labelColor = isDark ? "#F5EFE3" : "var(--qv3-gold, #FF1744)";
  const ruleColor = "rgba(255,23,68,0.45)";

  return (
    <aside
      data-testid="nanae-disclaimer"
      aria-label="Avertissement Hōjin"
      style={{
        maxWidth: 680,
        margin: "40px auto 8px",
        padding: "18px 24px 4px",
        borderTop: `0.5px solid ${ruleColor}`,
      }}
    >
      <div
        style={{
          fontFamily: "var(--qv3-font-mono, 'DM Mono', monospace)",
          fontSize: 10,
          fontWeight: 500,
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: labelColor,
          marginBottom: 12,
          textAlign: "center",
        }}
      >
        · Avertissement ·
      </div>
      <p
        style={{
          fontFamily:
            "var(--qv3-font-serif, 'Playfair Display', Georgia, serif)",
          fontStyle: "italic",
          fontWeight: 400,
          fontSize: 13.5,
          lineHeight: 1.65,
          letterSpacing: "0.005em",
          color: bodyColor,
          margin: 0,
          textAlign: "center",
          maxWidth: 620,
          marginInline: "auto",
        }}
      >
        {variant === "verif" ? (
          <>
            Ces observations sont neutres et destinées à préparer vos échanges
            avec un professionnel habilité — elles ne constituent pas un avis
            juridique. Hōjin n’est pas un cabinet d’avocats et ne fournit pas
            de conseil juridique, fiscal ou comptable. Seul un professionnel
            habilité peut se prononcer sur votre situation.
          </>
        ) : (
          <>
            Hōjin ne remplace pas votre conseil. Hōjin n’est pas un cabinet
            d’avocats, d’expertise comptable ni de conseil financier, et ne
            fournit pas de conseil juridique, fiscal ou comptable. Ces
            analyses ne se substituent pas à l’avis d’un professionnel
            habilité, seul à même de se prononcer sur votre situation. Elles
            ont pour but de vous aider à mieux préparer et comprendre vos
            échanges avec vos conseils.
          </>
        )}
      </p>
    </aside>
  );
}

export default NanaeDisclaimer;
